










import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SellersCampaignsSummary from "./SellersCampaignsSummary.vue";
import SellersCampaignsDetails from "./SellersCampaignsDetails.vue";
import User from "@/models/user";
import { ReportModule } from "@/store/report";
import ReportsAPI from "@/services/reports";
import { LayoutModule } from "@/store/layout";
import Campaign from "@/models/campaign";

@Component({ components: { SellersCampaignsSummary, SellersCampaignsDetails } })
export default class SellersCampaigns extends Vue {
  @Prop({ default: false }) summary!: boolean;
  data: Campaign[] = [];
  created(): void {
    // Clean selected user
    ReportModule.setUserFilter([]);
  }

  get selectedUser(): User[] {
    return ReportModule.userFilter;
  }

  @Watch("selectedUser")
  async getReport(): Promise<void> {
    LayoutModule.showLoader();
    try {
      const user_ids = this.selectedUser.map((u) => u.id);
      const r = await ReportsAPI.sellersCampaigns(user_ids);
      this.data = r;
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }
}
